import React, { useEffect } from "react";
import { Sidebar } from "primereact/sidebar";
import foodGIF from "../../assets/food/food.gif";
import { ProceedButton } from "src/styled-components/generalTags";
import FlexiLogo from "../../assets/flexi/FLEXISHOW-LOGO-WHITE.svg";
import cross from "../../assets/flexi/cross.svg";

import inoxpvrst from "../../assets/super-ticket/inox-st.png";
import dummy from "../../assets/super-ticket/dummy.png";
import "./superticketPopup.css";
function SuperTicketHowItWork({ visible, content, setVisible }) {
  const theme = localStorage.getItem("theme");
  const isMobile = window.matchMedia("(max-width: 575px)").matches;
  
  useEffect(() => {
  }, [visible]);
  return (
    <div>
      <Sidebar
        visible={visible}
        showCloseIcon={true}
        showHeader={true}
        position={isMobile ? "bottom" : "right"}
        className="flexi-terms-cond"
        onHide={() => {
          setVisible(false);
        }}
        dismissable={true}>
          {/* <div className="flexi-cross-how show-in-desktop-view">
          <img src={cross} alt="" className="img-fluid" onClick={() => {
                    setVisible(false);
                  }} />
        </div> */}
        <div className="row">
        <div className="container">
        <div className="col-lg-12 col-sm-12">
          <p>Curious About SuperTicket ?</p>
          <img src={content?.hiwUrl}  className="img-fluid"/>
          <div className="st-hiw-button-box">
          <ProceedButton className="how-it-okay" onClick={() => {
                    setVisible(false);
                  }}>
               Okay
            </ProceedButton>
          </div>
          </div>
          </div>
          </div>
        {/* 
        <div className="row">
          <div className="col-lg-12 col-sm-12">
        <div className="st-hit-grad">
          <div className="st-hiw-heading"><img src={inoxpvrst} alt="" className="img-fluid" />
            <p></p>
            <p>Purchase movie tickets<br/>
            using super-Tickets</p>
          </div>
        </div>
        <div>
          <div className="st-hiw-body">
            <div className="st-hiw-body-content">
              <p>1. To book a Super-Ticket show simply select from lore ipsum..</p>

              <img src={dummy} alt="" className="img-fluid" />
            </div>

            <div className="st-hiw-body-content">
              <p>2. To book a Super-Ticket show simply select from lore ipsum..</p>

              <img src={dummy} alt="" className="img-fluid" />
            </div>

            <div className="st-hiw-body-content-condition">
              <h1>Conditions for ease of use</h1>
              <ol>
                <li>The app would automatically sync with the sound from the main cinema screen to adapt the playback, you need not do anything. the audio file requires cinema sound to play, so ensure movie has started before you play the audio file</li>
                <li>The app would automatically sync with the sound from the main cinema screen to adapt the playback, you need not do anything. the audio file requires cinema sound to play, so ensure movie has started before you play the audio file</li>
                <li>The app would automatically sync with the sound from the main cinema screen to adapt the playback, you need not do anything. the audio file requires cinema sound to play, so ensure movie has started before you play the audio file</li>
              </ol>
            </div>

            <div className="st-hiw-body-content-condition">
              <h1>Rules & Exceptions</h1>
              <ol>
                <li>The app would automatically sync with the sound from the main cinema screen to adapt the playback, you need not do anything. the audio file requires cinema sound to play, so ensure movie has started before you play the audio file</li>
                <li>The app would automatically sync with the sound from the main cinema screen to adapt the playback, you need not do anything. the audio file requires cinema sound to play, so ensure movie has started before you play the audio file</li>
                <li>The app would automatically sync with the sound from the main cinema screen to adapt the playback, you need not do anything. the audio file requires cinema sound to play, so ensure movie has started before you play the audio file</li>
              </ol>
            </div>
          </div>
          <div className="st-hiw-button-box">
          <ProceedButton className="how-it-okay" onClick={() => {
                    setVisible(false);
                  }}>
          Buy Super Ticket
            </ProceedButton>
          </div>
        </div>
        </div>
        </div> */}
         
      </Sidebar>
    </div>
  );
}

export default SuperTicketHowItWork;
